export default {
  "de-DE": {
    "btn.officialwebsite": "Fire Emblem HeroesOffizielle Website",
    "btn.about": "Über diese Website",
    "btn.close": "Zurück",
    "footer.heading.share": "Teile diese Website:",
    "footer.btn.agreement": "Informationen zum Event",
    "trademark": "Apple und das Apple-Logo sind Marken der Apple Inc., die in den USA und weiteren Ländern eingetragen sind. App Store ist eine Dienstleistungsmarke der Apple Inc.<br>Google Play und das Google Play-Logo sind Marken von Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "Die bestplatzierten Helden erscheinen in besonderen \"Wähle deine Legenden\"-Outfits!",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Wähle deine Legenden: Runde 4",
    "header.menu": "Menü",
    "description001": "Möchtest du deine Lieblingshelden in besonderer Kleidung sehen? Es ist Zeit, erneut zu wählen!",
    "description002": "Die Helden, die in besonderer Kleidung erscheinen, wurden gewählt.",
    "footer.share.top": "Kampfvorbereitung: Fire Emblem Heroes<br>Wähle deine Legenden<br>{{url}}<br>#FEChoose",
    "footer.share.cheer": "Wähle {{hero_name}} in Fire Emblem Heroes: Wähle deine Legenden!<br>{{url}}<br>#FEChoose",
    "footer.share.voted": "Ich habe in Fire Emblem Heroes: Wähle deine Legenden {{hero_name}} gewählt!<br>{{url}}<br>#FEChoose",
    "footer.share.random": "Im \"Wähle deine Legenden\"-Event von Fire Emblem Heroes kannst du einen zufälligen Helden wählen:<br>{{url}}<br>#FEChoose",
    "footer.share.result": "Fire Emblem Heroes: Hier sind die Ergebnisse!<br>{{url}}<br>#FEChoose",
    "title": "Fire Emblem Heroes - Wähle deine Legenden: Runde 4",
    "title.cheer": "Fire Emblem Heroes - Wähle deine Legenden: Runde 4 - <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Wähle deine Legenden: Runde 4 - Du hast <?=h($hero_name)?> gewählt!",
    "title.result": "Fire Emblem Heroes - Wähle deine Legenden: Runde 4 - Ergebnisse",
    "footer.back": "Zurück",
    "footer.share002": "Hol dir Unterstützung!"
  },
  "en-GB": {
    "btn.officialwebsite": "Fire Emblem Heroesofficial site",
    "btn.about": "About This Site",
    "btn.close": "Close",
    "footer.heading.share": "Share this site:",
    "footer.btn.agreement": "Event Details",
    "trademark": "Apple and the Apple logo are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc.Google Play and the Google Play logo are trademarks of Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "The top-ranked Heroes will appear in special Choose Your Legends outfits!",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Choose Your Legends: Round 4",
    "header.menu": "Menu",
    "description001": "Want to see your favorite Heroes in special outfits? It's time to make your choice again!",
    "description002": "The Heroes that will appear in special outfits have been chosen.",
    "footer.share.top": "Prepare for mobile battle in the Fire Emblem Heroes<br>Choose Your Legends event.<br>{{url}}<br>#FEChoose",
    "footer.share.cheer": "I want you to choose {{hero_name}} in the Fire Emblem Heroes Choose Your Legends event!<br>{{url}}<br>#FEChoose",
    "footer.share.voted": "I picked {{hero_name}} in the Fire Emblem Heroes Choose Your Legends event!<br>{{url}}<br>#FEChoose",
    "footer.share.random": "You can choose a random Hero in the Fire Emblem Heroes Choose Your Legends event:<br>{{url}}<br>#FEChoose",
    "footer.share.result": "Fire Emblem Heroes: See the final results here!<br>{{url}}<br>#FEChoose",
    "title": "Fire Emblem Heroes - Choose Your Legends: Round 4",
    "title.cheer": "Fire Emblem Heroes - Choose Your Legends: Round 4 - <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Choose Your Legends: Round 4 - You chose <?=h($hero_name)?>!",
    "title.result": "Fire Emblem Heroes - Choose Your Legends: Round 4 - Results",
    "footer.back": "Back",
    "footer.share002": "Gather support"
  },
  "es-ES": {
    "btn.officialwebsite": "Sitio oficial deFire Emblem Heroes",
    "btn.about": "Acerca de este sitio",
    "btn.close": "Cerrar",
    "footer.heading.share": "Comparte este sitio:",
    "footer.btn.agreement": "Detalles de la campaña",
    "trademark": "Apple y el logo de Apple son marcas registradas de Apple Inc. en Estados Unidos y en otros países. App Store es una marca de servicio de Apple Inc.Google Play y el logo de Google Play son marcas registradas de Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "¡Los héroes que alcancen las posiciones más altas tendrán atuendos especiales de Elige a tus héroes!",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Elige a tus héroes (4)",
    "header.menu": "Menú",
    "description001": "¿Quieres ver a tus héroes favoritos con atuendos especiales? ¡Tú puedes decidirlo!",
    "description002": "Se han elegido los héroes que llevarán un atuendo especial.",
    "footer.share.top": "Lucha en dispositivos inteligentes: Fire Emblem Heroes<br>Elige a tus héroes<br>{{url}}<br>#FEHeroes",
    "footer.share.cheer": "¡Apoyad a {{hero_name}} en Elige a tus héroes de Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.voted": "¡He votado a {{hero_name}} en Elige a tus héroes de Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.random": "Puedes elegir a un héroe al azar en Elige a tus héroes de Fire Emblem Heroes<br>{{url}}<br>#FEHeroes",
    "footer.share.result": "Fire Emblem Heroes: ¡Ya puedes ver los resultados finales!<br>{{url}}<br>#FEHeroes",
    "title": "Fire Emblem Heroes - Elige a tus héroes (4)",
    "title.cheer": "Fire Emblem Heroes - Elige a tus héroes (4): <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Elige a tus héroes (4): ¡He elegido a <?=h($hero_name)?>!",
    "title.result": "Fire Emblem Heroes - Elige a tus héroes (4): Resultados",
    "footer.back": "Atrás",
    "footer.share002": "¡Consigue apoyos!"
  },
  "fr-FR": {
    "btn.officialwebsite": "Site officiel deFire Emblem Heroes",
    "btn.about": "À propos du site",
    "btn.close": "Fermer",
    "footer.heading.share": "Partager ce site",
    "footer.btn.agreement": "À propos de l'événement",
    "trademark": "Apple et le logo Apple sont des marques d’Apple Inc., déposées aux États-Unis et dans d’autres pays. App Store est une marque de service d’Apple Inc.Google Play et le logo Google Play sont des marques de Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "Les héros les plus populaires apparaîtront dans des tenues spéciales !",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Choisissez vos héros n° 4",
    "header.menu": "Menu",
    "description001": "Vous voulez voir votre héros favori dans une tenue spéciale ? Alors il est temps de voter !",
    "description002": "Les héros qui apparaîtront dans des tenues spéciales ont été désignés.",
    "footer.share.top": "Fire Emblem Heroes - Choisissez vos héros<br>Préparez-vous.<br>{{url}}<br>#FEHeroes",
    "footer.share.cheer": "Votez pour {{hero_name}} dans Fire Emblem Heroes - Choisissez vos héros !<br>{{url}}<br>#FEHeroes",
    "footer.share.voted": "J'ai voté pour {{hero_name}} dans Fire Emblem Heroes - Choisissez vos héros !<br>{{url}}<br>#FEHeroes",
    "footer.share.random": "Choisissez un héros au hasard dans Fire Emblem Heroes - Choisissez vos héros<br>{{url}}<br>#FEHeroes",
    "footer.share.result": "Fire Emblem Heroes - Choisissez vos héros<br>Voici les résultats :<br>{{url}}<br>#FEHeroes",
    "title": "Fire Emblem Heroes - Choisissez vos héros n° 4",
    "title.cheer": "Fire Emblem Heroes - Choisissez vos héros n° 4 : <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Choisissez vos héros n° 4 : j'ai voté pour <?=h($hero_name)?> !",
    "title.result": "Fire Emblem Heroes - Choisissez vos héros n° 4 : résultats",
    "footer.back": "Retour",
    "footer.share002": "Rassembler du soutien"
  },
  "it-IT": {
    "btn.officialwebsite": "Sito ufficiale diFire Emblem Heroes",
    "btn.about": "Informazioni su questo sito",
    "btn.close": "Chiudi",
    "footer.heading.share": "Condividi su:",
    "footer.btn.agreement": "Dettagli sull'evento",
    "trademark": "Apple e il logo Apple sono marchi di Apple Inc., registrati negli Stati Uniti e in altri Paesi. App Store è un marchio di servizio di Apple Inc.<br>Google Play e il logo di Google Play sono marchi di Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "I personaggi che otterranno i primi posti appariranno con un completo speciale Scegli le tue leggende!",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Scegli le tue leggende 4",
    "header.menu": "Menu",
    "description001": "Vuoi far indossare completi speciali ai tuoi eroi preferiti? È di nuovo il momento di dire la tua.",
    "description002": "Gli eroi che indosseranno completi speciali sono stati scelti.",
    "footer.share.top": "Preparati alla lotta portatile con Fire Emblem Heroes!<br>Scegli le tue leggende.<br>{{url}}<br>#FEHeroes",
    "footer.share.cheer": "Scegli {{hero_name}} in Scegli le tue leggende per Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.voted": "Ho scelto {{hero_name}} in Scegli le tue leggende per Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.random": "In Scegli le tue leggende per Fire Emblem Heroes puoi scegliere un eroe casuale:<br>{{url}}<br>#FEHeroes",
    "footer.share.result": "Sono disponibili i risultati dell'evento Scegli le tue leggende 4 su Fire Emblem Heroes: scopri chi ha vinto!<br>{{url}}<br>#FEHeroes",
    "title": "Fire Emblem Heroes - Scegli le tue leggende 4",
    "title.cheer": "Fire Emblem Heroes - Scegli le tue leggende 4: <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Scegli le tue leggende 4: hai scelto <?=h($hero_name)?>!",
    "title.result": "Fire Emblem Heroes - Scegli le tue leggende 4: risultati",
    "footer.back": "Indietro",
    "footer.share002": "Cerca sostegno"
  },
  "ja-JP": {
    "btn.officialwebsite": "ファイアーエムブレムヒーローズ公式サイトへ",
    "btn.about": "英雄総選挙とは",
    "btn.close": "とじる",
    "footer.heading.share": "このページをシェア",
    "footer.btn.agreement": "英雄総選挙の詳細",
    "trademark": "Apple および Apple ロゴは米国その他の国で登録された Apple Inc. の商標です。App Store は Apple Inc. のサービスマークです<br>Google Play および Google Play ロゴは、Google LLC の商標です",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "上位の英雄が総選挙特別衣装で登場！",
    "header.title001": "ファイアーエムブレム ヒーローズ",
    "header.title002": "第4回 英雄総選挙",
    "header.menu": "MENU",
    "description001": "特別衣装で登場するのは誰だ！？歴代英雄たちの総選挙を今年も開催！",
    "description002": "特別衣装で登場する英雄が決定！",
    "footer.share.top": "『ファイアーエムブレム ヒーローズ』<br>第4回英雄総選挙<br>#FE英雄総選挙<br>{{url}}",
    "footer.share.cheer": "『ファイアーエムブレム ヒーローズ』<br>第4回英雄総選挙で、{{hero_name}}を応援しています！<br>#FE英雄総選挙<br>{{url}}",
    "footer.share.voted": "『ファイアーエムブレム ヒーローズ』<br>第4回英雄総選挙で、{{hero_name}}に投票しました！<br>#FE英雄総選挙<br>{{url}}",
    "footer.share.random": "『ファイアーエムブレム ヒーローズ』<br>第4回英雄総選挙<br>ランダム投票<br>#FE英雄総選挙<br>{{url}}",
    "footer.share.result": "『ファイアーエムブレム ヒーローズ』第4回英雄総選挙<br>結果発表<br>#FE英雄総選挙<br>{{url}}",
    "title": "『ファイアーエムブレム ヒーローズ』第4回 英雄総選挙",
    "title.cheer": "『ファイアーエムブレム ヒーローズ』第4回 英雄総選挙で、「<?=h($hero_name)?>」を応援しています！",
    "title.voted": "『ファイアーエムブレム ヒーローズ』第4回 英雄総選挙で、 「<?=h($hero_name)?>」に投票しました！",
    "title.result": "『ファイアーエムブレム ヒーローズ』第4回 英雄総選挙 結果発表",
    "footer.back": "もどる",
    "footer.share002": "応援シェアする"
  },
  "zh-TW": {
    "btn.officialwebsite": "前往Fire Emblem Heroes官方網站",
    "btn.about": "英雄總選舉是什麼？",
    "btn.close": "關閉",
    "footer.heading.share": "分享此頁面",
    "footer.btn.agreement": "英雄總選舉之詳情",
    "trademark": "Apple及Apple標誌是從美國或其他國家登錄的Apple Inc. 商標。App Store為Apple Inc. 的服務商標。<br>Google Play及Google Play標誌是Google LLC 的商標。",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "排名前面的英雄將會以總選舉特別服裝登場！",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "第4回 英雄總選舉",
    "header.menu": "MENU",
    "description001": "究竟誰會以特別服裝登場！？今年也將舉辦歷代英雄總選舉！",
    "description002": "選出穿著特別服裝登場的英雄！",
    "footer.share.top": "「Fire Emblem Heroes」<br>第4回英雄總選舉<br>#FE英雄總選舉<br>{{url}}",
    "footer.share.cheer": "「Fire Emblem Heroes」<br>在第4回英雄總選舉中支持{{hero_name}}！<br>#FE英雄總選舉<br>{{url}}",
    "footer.share.voted": "「Fire Emblem Heroes」<br>在第4回英雄總選舉中投票給{{hero_name}}！<br>#FE英雄總選舉<br>{{url}}",
    "footer.share.random": "「Fire Emblem Heroes」<br>第4回英雄總選舉<br>隨機投票<br>#FE英雄總選舉<br>{{url}}",
    "footer.share.result": "「Fire Emblem Heroes」第4回英雄總選舉<br>公布結果<br>#FE英雄總選舉<br>{{url}}",
    "title": "「Fire Emblem Heroes」第4回 英雄總選舉",
    "title.cheer": "「Fire Emblem Heroes」第4回 英雄總選舉中支持「<?=h($hero_name)?>」！",
    "title.voted": "「Fire Emblem Heroes」第4回 英雄總選舉中投票給 「<?=h($hero_name)?>」！",
    "title.result": "「Fire Emblem Heroes」 第4回 英雄總選舉 公布結果",
    "footer.back": "返回",
    "footer.share002": "分享支持訊息"
  },
  "en-US": {
    "btn.officialwebsite": "Fire Emblem HeroesOfficial Site",
    "btn.about": "About This Site",
    "btn.close": "Close",
    "footer.heading.share": "Share this site:",
    "footer.btn.agreement": "Event Details",
    "trademark": "Apple and the Apple logo are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc.<br>Google Play and the Google Play logo are trademarks of Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "The top-ranked Heroes will appear in special Choose Your Legends outfits!",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Choose Your Legends: Round 4",
    "header.menu": "Menu",
    "description001": "Want to see your favorite Heroes in special outfits? It's time to make your choice again!",
    "description002": "The Heroes that will appear in special outfits have been chosen.",
    "footer.share.top": "Prepare for mobile battle in the Fire Emblem Heroes<br>Choose Your Legends event.<br>{{url}}<br>#FEChoose",
    "footer.share.cheer": "I want you to choose {{hero_name}} in the Fire Emblem Heroes Choose Your Legends event!<br>{{url}}<br>#FEChoose",
    "footer.share.voted": "I picked {{hero_name}} in the Fire Emblem Heroes Choose Your Legends event!<br>{{url}}<br>#FEChoose",
    "footer.share.random": "You can choose a random Hero in the Fire Emblem Heroes Choose Your Legends event:<br>{{url}}<br>#FEChoose",
    "footer.share.result": "Fire Emblem Heroes: See the final results here!<br>{{url}}<br>#FEChoose",
    "title": "Fire Emblem Heroes - Choose Your Legends: Round 4",
    "title.cheer": "Fire Emblem Heroes - Choose Your Legends: Round 4 - <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Choose Your Legends: Round 4 - You chose <?=h($hero_name)?>!",
    "title.result": "Fire Emblem Heroes - Choose Your Legends: Round 4 - Results",
    "footer.back": "Back",
    "footer.share002": "Gather support"
  },
  "es-MX": {
    "btn.officialwebsite": "Sitio web oficial deFire Emblem Heroes",
    "btn.about": "Más información",
    "btn.close": "Cerrar",
    "footer.heading.share": "Comparte este sitio:",
    "footer.btn.agreement": "Detalles del evento",
    "trademark": "Apple y el logo de Apple son marcas registradas de Apple Inc. en Estados Unidos y en otros países. App Store es una marca de servicio de Apple Inc.<br>Google Play y el logo de Google Play son marcas registradas de Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "¡Los héroes que alcancen las posiciones más altas tendrán atuendos especiales de Elige a tus leyendas!",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Elige a tus leyendas (4)",
    "header.menu": "Menú",
    "description001": "¿Quieres ver a tus héroes favoritos con atuendos especiales? ¡Tú puedes decidirlo!",
    "description002": "Se han elegido los héroes que llevarán un atuendo especial.",
    "footer.share.top": "Prepárate para el combate en dispositivos móviles: Fire Emblem Heroes<br>Elige a tus leyendas<br>{{url}}<br>#FEHeroes",
    "footer.share.cheer": "¡Apoyen a {{hero_name}} en Elige a tus leyendas de Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.voted": "¡Yo elegí a {{hero_name}} en Elige a tus leyendas de Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.random": "Puedes elegir un héroe al azar en el evento Elige a tus leyendas de Fire Emblem Heroes:<br>{{url}}<br>#FEHeroes",
    "footer.share.result": "Fire Emblem Heroes: ¡Ya puedes ver los resultados finales!<br>{{url}}<br>#FEHeroes",
    "title": "Fire Emblem Heroes - Elige a tus leyendas (4)",
    "title.cheer": "Fire Emblem Heroes - Elige a tus leyendas (4): <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Elige a tus leyendas (4): ¡He elegido a <?=h($hero_name)?>!",
    "title.result": "Fire Emblem Heroes - Elige a tus leyendas (4): Resultados",
    "footer.back": "Atrás",
    "footer.share002": "¡Consigue apoyos!"
  },
  "fr-CA": {
    "btn.officialwebsite": "Site officiel deFire Emblem Heroes",
    "btn.about": "À propos du site",
    "btn.close": "Fermer",
    "footer.heading.share": "Partager ce site",
    "footer.btn.agreement": "À propos de l'événement",
    "trademark": "Apple et le logo Apple sont des marques d’Apple Inc., déposées aux États-Unis et dans d’autres pays. App Store est une marque de service d’Apple Inc.<br>Google Play et le logo Google Play sont des marques de Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "Les héros qui apparaîtront dans des tenues spéciales ont été désignés.",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Choisissez vos héros n° 4",
    "header.menu": "Menu",
    "description001": "Vous voulez voir votre héros favori dans une tenue spéciale? Alors il est temps de voter!",
    "description002": "Les héros qui apparaîtront dans des tenues spéciales ont été désignés.",
    "footer.share.top": "Fire Emblem Heroes - Choisissez vos héros<br>Préparez-vous.<br>{{url}}<br>#FEHeroes",
    "footer.share.cheer": "Votez pour {{hero_name}} dans Fire Emblem Heroes - Choisissez vos héros!<br>{{url}}<br>#FEHeroes",
    "footer.share.voted": "J'ai voté pour {{hero_name}} dans Fire Emblem Heroes - Choisissez vos héros!<br>{{url}}<br>#FEHeroes",
    "footer.share.random": "Choisissez un héros au hasard dans Fire Emblem Heroes - Choisissez vos héros<br>{{url}}<br>#FEHeroes",
    "footer.share.result": "Fire Emblem Heroes - Choisissez vos héros<br>Voici les résultats :<br>{{url}}<br>#FEHeroes",
    "title": "Fire Emblem Heroes - Choisissez vos héros n° 4",
    "title.cheer": "Fire Emblem Heroes - Choisissez vos héros n° 4 : <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Choisissez vos héros n° 4 : j'ai voté pour <?=h($hero_name)?>!",
    "title.result": "Fire Emblem Heroes - Choisissez vos héros n° 4 : résultats",
    "footer.back": "Retour",
    "footer.share002": "Rassembler du soutien"
  },
  "pt-BR": {
    "btn.officialwebsite": "Página oficial deFire Emblem Heroes",
    "btn.about": "Sobre esta página",
    "btn.close": "Fechar",
    "footer.heading.share": "Compartilhe esta página:",
    "footer.btn.agreement": "Detalhes do evento",
    "trademark": "Apple e o logotipo da Apple logo são marcas registradas da Apple Inc., registrados nos EUA e em outros países. App Store é uma marca de serviço da Apple Inc.<br>Google Play e o logotipo do Google Play são marcas registradas da Google LLC.",
    "copyright": "© 2017 Nintendo / INTELLIGENT SYSTEMS",
    "header.text001": "Os heróis mais votados aparecerão em vestimentas especiais do evento \"Escolha suas lendas\"!",
    "header.title001": "Fire Emblem Heroes",
    "header.title002": "Escolha suas lendas (4)",
    "header.menu": "Menu",
    "description001": "Quer ver os seus heróis favoritos em vestimentas especiais? É a hora de fazer a sua escolha novamente!",
    "description002": "Os heróis que aparecerão em vestimentas especiais foram escolhidos.",
    "footer.share.top": "Prepare-se para batalhas em dispositivos inteligentes: Fire Emblem Heroes<br>Escolha suas lendas.<br>{{url}}<br>#FEHeroes",
    "footer.share.cheer": "Quero que você escolha {{hero_name}} no evento \"Escolha suas lendas\" de Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.voted": "Eu escolhi {{hero_name}} no evento \"Escolha suas lendas\" de Fire Emblem Heroes!<br>{{url}}<br>#FEHeroes",
    "footer.share.random": "Você pode escolher um herói aleatório no evento \"Escolha suas lendas\" de Fire Emblem Heroes:<br>{{url}}<br>#FEHeroes",
    "footer.share.result": "Fire Emblem Heroes: Confira os resultados finais!<br>{{url}}<br>#FEHeroes",
    "title": "Fire Emblem Heroes - Escolha suas lendas (4)",
    "title.cheer": "Fire Emblem Heroes - Escolha suas lendas (4) - <?=h($hero_name)?>",
    "title.voted": "Fire Emblem Heroes - Escolha suas lendas (4) - Você escolheu <?=h($hero_name)?>!",
    "title.result": "Fire Emblem, Heroes - Escolha suas lendas (4) - Resultados",
    "footer.back": "Voltar",
    "footer.share002": "Consiga ajuda!"
  }
}